import { useEffect } from "react";
import { useSelector } from "react-redux";
import { generatePath, useLocation, useNavigate, useParams } from "react-router-dom";
import { selectUserData } from "redux/AuthSlice/index.slice";
import { getCompletePathList } from "route";
import { AuthDriver as authDriver, modalNotification, removeLocalStorageToken } from "utils";

/**
 * Functional component representing the main application layout.
 * Manages user authentication, redirects, and renders children components.
 * @param {Object} setRedirectPath - Function to set the redirection path.
 * @param {ReactNode} children - The components to be rendered within the layout.
 */
function AppLayout({ setRedirectPath, children }) {
  const location = useLocation();
  const params = useParams();
  const userData = useSelector(selectUserData);
  const navigate = useNavigate();
  /**
   * Function to generate a path based on the provided data and parameters.
   * @param {string} data - The path template.
   * @returns {string} - The generated path.
   */
  function getGeneratedPath(data) {
    try {
      return generatePath(data, params);
    } catch (error) {
      return data;
    }
  }

  // Find the active route based on the current browser path
  const activeRoute = getCompletePathList().find((e) => {
    const routePath = getGeneratedPath(e.key);
    const browserPath = location.pathname;
    return routePath === browserPath;
  });

  // const activeRoute = getCompletePathList().find(e => e.key === location.pathname);
  // const activeRoute = getCompletePathList().find(e => e.key.search(location.pathname.replace(/[0-9]/g, '')) >=0)
  const isPrivate = activeRoute?.private;
  const isValid = authDriver(activeRoute, userData, location.pathname);

  /**
   * Function to check the validity of the user and redirect accordingly.
   */
  function checkValid() {
    if (!isValid) {
      let publicPath = "/instructor";
      let privatePath = "/instructor/dashboard";
      let checkData = userData?.user?.role;
      if (checkData === "instructor") {
        privatePath = "/instructor/dashboard";
        publicPath = "/instructor";
      }

      if (isPrivate === true) {
        /** ******* If route type is private but not*****************
         * ******* able to prove their identity as valid entity*****
         * ********* so redirect it to public route******** */
        modalNotification({
          type: "warning",
          message: "Your Token is expired. Please login again.",
        });
        removeLocalStorageToken();
        navigate(publicPath);
        // setRedirectPath(publicPath);
        // return false;
      } else if (isPrivate === false) {
        /** ******* If route type is public but not*****************
         * ******* able to prove their identity as valid entity*****
         * ********* so redirect it to private route******** */
        setRedirectPath(privatePath);
      }
    } else {
      // setRedirectPath(location.pathname);
    }
  }

  useEffect(() => {
    checkValid();
  }, [location.pathname]);

  // Render children components only if the user is valid
  return <>{isValid && children}</>;
}

export default AppLayout;
